var _path, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgInfoSelfHelp(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.8835 17.9434C13.8096 18.1229 13.6339 18.24 13.44 18.24H12.48H11.52H10.56C10.3661 18.24 10.1904 18.1229 10.1165 17.9434C10.0425 17.7638 10.0838 17.5575 10.2211 17.4202L11.04 16.6013V11.2387L10.2211 10.4189C10.0838 10.2816 10.0425 10.0752 10.1165 9.89564C10.1904 9.71611 10.3661 9.59995 10.56 9.59995H11.52H12H12.48C12.7449 9.59995 12.96 9.81403 12.96 10.08V16.6012L13.7798 17.4201C13.9162 17.5575 13.9575 17.7638 13.8835 17.9434ZM12 5.76C12.7939 5.76 13.44 6.40514 13.44 7.2C13.44 7.99392 12.7939 8.64 12 8.64C11.2061 8.64 10.56 7.99392 10.56 7.2C10.56 6.40514 11.2061 5.76 12 5.76ZM12 0C5.38369 0 0 5.3827 0 12C0 18.6163 5.38369 24 12 24C18.6173 24 24 18.6163 24 12C24 5.3827 18.6173 0 12 0Z",
    fill: "url(#paint0_linear_23158_4367)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_23158_4367",
    x1: -11.3333,
    y1: 2,
    x2: 25.3333,
    y2: 20.6667,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6111E3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7B2AFF"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInfoSelfHelp);
export default __webpack_public_path__ + "static/media/infoSelfHelp.7b4552c4d638ca73a884f532a3d61f08.svg";
export { ForwardRef as ReactComponent };